import { Text } from "@react-pdf/renderer";
import { formatDateTimeUtc } from "../../../utils/date_formatter";
import Tag from "../ReactPdfComponents/ReactPdfTag";

export const formatTableDataLabel = (key: string) => {
	return key
		.replace(/([A-Z])/g, " $1") // split camelCase
		.replace(/_/g, " ") // replace underscores
		.trim()
		.toLowerCase()
		.replace(/^\w/, (c) => c.toUpperCase()); // only capitalize first char
};

export const formatDate = (isoString: string): string => {
	if (!isoString) return "";
	const date = new Date(isoString);

	const options: Intl.DateTimeFormatOptions = {
		day: "numeric",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: true,
	};

	// Format date
	const formatted = new Intl.DateTimeFormat("en-GB", options).format(date);

	// Uppercase AM/PM
	return formatted.replace(/am|pm/i, (match) => match.toUpperCase());
};

// Generic Tag wrapper for @react-pdf/renderer
// - Wrap ANY child; if it's a primitive string/number, render inside a Text node
// - Optional style overrides for container and text

// Convenience helper to render content as a Tag without JSX in the caller
export const renderAsTag = (content: any): JSX.Element => {
	return <Tag>{content}</Tag>;
};

// "Approved on" cell of the approval record. approved_on is stamped when the
// reviewer approves the initial review; a closed report without it has no
// recorded approval date, so it gets a dash rather than "Pending approval".
export const renderApprovedOn = (data: Record<string, any>) => {
	if (data?.approved_on) return formatDateTimeUtc(data.approved_on);
	if (data?.status === "closed") return "—";
	return <Text style={{ fontStyle: "italic" }}>Pending approval</Text>;
};

export const formatResponsiblePerson = (
	responsible?: string | null,
	responsibleName?: string | null
): string | null => {
	const email = responsible ? String(responsible).trim() : "";
	const name = responsibleName ? String(responsibleName).trim() : "";

	if (!email && !name) return null;
	if (email && name && email.toLowerCase() !== name.toLowerCase()) {
		return `${name} (${email})`;
	}
	return name || email;
};
